<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div id="printable-area">
  <div class="header-div">
    <div class="header-text">
      <h2>
        @if (displaying === 'team') {
          <span>{{ selectedTeam.shortName }}'s</span>
        }
        @if (displaying !== 'team') {
          <span>{{ loggedInUserName }}'s</span>
        }
        Responses for {{ selectedEvaluation.description }}
      </h2>
    </div>
    <div class="right-buttons no-print">
      <button
        aria-label="Toggle between user and team scores"
        mat-icon-button
        style="outline: none;"
        title="Toggle between user and team scores"
        (click)="toggleDisplaying()"
        >
        <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-swap-horizontal"></mat-icon>
      </button>
      <button
        aria-label="Print Submission Review"
        mat-icon-button
        style="outline: none;"
        title="Print Submission Review"
        (click)="printpage()"
        >
        <mat-icon aria-hidden="false" class="mdi-24px" fontIcon="mdi-printer"></mat-icon>
      </button>
    </div>
  </div>
  @for (submission of displayedSubmissionList; track submission.id) {
    <mat-table [dataSource]="getDisplayedScoringCategories(submission.moveNumber) | displayOrder" class="full-width"
      >
      <!-- Description Definition -->
      <ng-container matColumnDef="scoringCategoryDescription">
        <mat-header-cell *matHeaderCellDef class="cssLayoutRowSpaceBetween">
          <div class="title-font">
            Move {{ submission.moveNumber }}
            @if (!selectedScoringModel?.hideScoresOnScoreSheet) {
              <span title="{{ displayedScoreHover }}"> - {{
                submission.score | number: '1.2-2' }}
              </span>
            }
          </div>
        </mat-header-cell>
        <!-- Report display -->
        <mat-cell *matCellDef="let scoringCategory" class="description-container">
          <div class="scoring-category-description">
            {{ scoringCategory.displayOrder }}. {{ scoringCategory.description }}
            @if (scoringCategory.calculationMethodId > 0) {
              <span>
                &nbsp;&nbsp;-&nbsp;&nbsp;[{{
                categoryScore(submission, scoringCategory.id) | number: '1.0-0'
                }}]
              </span>
            }
          </div>
          <mat-table [dataSource]="scoringCategory.scoringOptions | displayOrder" class="full-width">
            <ng-container matColumnDef="scoringOptionDescription" class="description-cell">
              <mat-cell *matCellDef="let scoringOption" class="description-container">
                <div [ngClass]="scoringOption.isModifier ? 'indent-div' : 'no-indent-div'">
                  <div class="score-option">
                    @if (scoringCategory.scoringOptionSelection !== 'None') {
                      <div class="checkbox-div">
                        <mat-checkbox [aria-label]="scoringOption.description"
                          [checked]="isSelected(submission, scoringCategory.id, scoringOption.id)" [disabled]="true"
                          [matTooltip]="selectedBy(submission, scoringCategory.id, scoringOption.id)">
                        </mat-checkbox>
                      </div>
                    }
                    <div class="description-div">
                      {{ scoringOption.description }} &nbsp;
                    </div>
                  </div>
                  @if (!selectedScoringModel.displayCommentTextBoxes) {
                    <div class="comment-list">
                      @for (
                        comment of optionComments(
                        submission,
                        scoringCategory.id,
                        scoringOption.id
                        )
                        ; track
                        comment.id) {
                        <div>
                          {{ comment.comment }}
                          @if (displaying === 'Team') {
                            <span> - {{ getUserName(comment.createdBy) }}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (selectedScoringModel.displayCommentTextBoxes) {
                    <div class="comment-box">
                      <span class="comment">{{ optionComments(submission, scoringCategory.id, scoringOption.id)[0]?.comment
                      }}</span>
                    </div>
                  }
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="value">
              <mat-cell *matCellDef="let scoringOption" class="value-container">
                @if (!selectedScoringModel?.hideScoresOnScoreSheet) {
                  <div class="value-div">
                    {{
                    scoringCategory.calculationMethodId == 0 ||
                    scoringOption.isModifier
                    ? ' '
                    : scoringOption.value
                    }}
                  </div>
                }
              </mat-cell>
            </ng-container>
            <mat-row *matRowDef="let row; columns: ['scoringOptionDescription', 'value']"></mat-row>
          </mat-table>
        </mat-cell>
      </ng-container>
      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="['scoringCategoryDescription']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['scoringCategoryDescription']"></mat-row>
    </mat-table>
  }
</div>
